import { _decorator, Component, CCBoolean, Node } from 'cc';
import OrientationManager, { Orientation } from '../../../OrientationManager';
import GameDependency from '../../../System/GameDependency';

const { ccclass, property } = _decorator;

@ccclass('OrientedBaseProperty')
export class OrientedBaseProperty {}

@ccclass('OrientedComponent')
export default abstract class OrientedComponent<T extends Node | Component> extends GameDependency {
    public readonly landscapeProperties: OrientedBaseProperty = null;
    public readonly portraitProperties: OrientedBaseProperty = null;

    private _target: T = null;
    private _editLandscapeMode: boolean = true;

    @property({ type: CCBoolean })
    public set editLandscapeMode(mode: boolean) {
        this._editLandscapeMode = mode;
        this.onOrientationChanged(mode ? Orientation.Landscape : Orientation.Portrait);
    }
    public get editLandscapeMode() {
        return this._editLandscapeMode;
    }

    public get target(): T {
        if (!this._target) {
            this._target = this.getTarget();
        }
        return this._target;
    }
    public set target(component: T) {
        this._target = component;
    }

    public get currentOrientationProperties(): OrientedBaseProperty {
        return this.game.orientation.isLandscape ? this.landscapeProperties : this.portraitProperties;
    }

    public onEnable(): void {
        this.game.orientation.on(OrientationManager.EVENT_TYPE.ORIENTATION_CHANGE, this.onOrientationChanged, this);
        this.onOrientationChanged(this.game.orientation.current);
    }

    public onDisable(): void {
        this.game.orientation.off(OrientationManager.EVENT_TYPE.ORIENTATION_CHANGE, this.onOrientationChanged, this);
    }

    public onOrientationChanged(newOrientation: Orientation) {
        this.updateOrientationProperties(newOrientation === Orientation.Landscape ? this.landscapeProperties : this.portraitProperties);
    }

    // 提供給 Extension 的按鈕使用
    private _setLandscape() {
        this.onOrientationChanged(Orientation.Landscape);
    }

    // 提供給 Extension 的按鈕使用
    private _setPortrait() {
        this.onOrientationChanged(Orientation.Portrait);
    }

    protected abstract updateOrientationProperties(properties: OrientedBaseProperty);

    protected abstract getTarget(): T;
}
